module.exports = __webpack_public_path__ + "img/web-proxy-secure-vpn.300e4c4c.webp";